import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    style: _normalizeStyle([_ctx.finalStyle, {"bottom":"-4px","top":"revert","left":"-16px","right":"-16px"}])
  }, null, 4))
}